import { render, staticRenderFns } from "./bankMortgages.vue?vue&type=template&id=182994fc&scoped=true&"
import script from "./bankMortgages.vue?vue&type=script&lang=js&"
export * from "./bankMortgages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182994fc",
  null
  
)

export default component.exports